import React from 'react';
import withView from '../../../cmn/docAutomation/withView';
import DashSCRow from './DashSCRow';
import SarasMenu from '../../../../library/repeater/menu/SarasMenu';
import * as uiJS from '../../../../helper/uiFunctions';

const DashShortCuts = (props) => {
    const { formObject, viewData, deviceInfo, menuTrigger } = props;
    
    if (!viewData)
        return (null);
    
    let data = formObject.getFormRow("","DashSC");
    const shortcuts = Object.values(data.rowValues);

    const onSelection = (event, index) => {
        const row = shortcuts[Number(index)];
        const href = row?.dataList?.href;

        if (!href) return;

        const targetUrl = uiJS.getAbsoluteAppLink(href);
        window.open(targetUrl, '_blank');
    };

    return (
        <SarasMenu
            menuContainerClass={deviceInfo.activateMobileView ? 'uiSelectedChipTrans' : 'uiViewActivatorBlue'}
            menuTrigger={menuTrigger}
            dataList={shortcuts}
            menuItem={DashSCRow}
            onSelection={onSelection}
            contentStyle={{ minWidth: '260px', maxWidth: '92vw' }}
            menuListClass="uiDashShortCutsMenuList"
        />
    )
}

export default withView(DashShortCuts, "dashShortcuts", "")
